/**
 * 页面类视图节点
 */
export const PAGE_LIST = {
  startNowPage: 'startNowPage', // 引导页1
  curpPage: 'curpPage', // curp页
  cardSeparatePersonalInfo1: 'cardSeparatePersonalInfo1', // 虚实分离个人信息1
  congratesPage: 'congratesPage', // 引导页2
  creditGrantPage: 'creditGrantPage', // 征信授权页
  phaseOneLoading: 'phaseOneLoading', // 一阶段loading
  curpConflictChangeOneSubmitPage: 'curpConflictChangeOneSubmitPage', // curp冲突一阶段提交页（页面为一阶段离线等待页）
}

export type TPage = keyof typeof CREDIT_ROUTE_MAP

/**
 * 申卡页面路由映射
 */
export const CREDIT_ROUTE_MAP = {
  startNowPage: 'apply_guide_one', // 引导页1
  curpPage: 'apply_curp', // curp页
  cardSeparatePersonalInfo1:
    'apply_person_info', // 虚实分离个人信息1
  congratesPage: 'apply_guide_two', // 引导页2
  creditGrantPage: 'apply_authorization', // 征信授权页
  phaseOneLoading: 'apply_stage_one_loading', // 一阶段loading
}

/**
 * 逻辑节点
 */

export const ACTION_LIST = {
  homePage: 'homePage', //首页
}

/**
 * 前端根据节点处理方式进行划分
 * 0代表错误兜底，即后端下发的节点标识有问题，前端不识别
 * 页面类视图节点：需要渲染页面，此节点下发后前端需进行相应路由跳转。
 * 弹窗类视图节点：仅拉起弹窗，且弹窗可以关闭。此节点下发后，前端在当前路由渲染弹窗组件。
 * 逻辑节点：无需渲染页面，仅需执行动作逻辑。此节点下发后，前端在当前路由执行相关函数
 */
export const NODE_TYPE = {
  ERROR: 0,
  PAGE: 1,
  POPUP: 2,
  ACTION: 3,
}

/**
 * ocr场景列表
 */
export const OCR_SCENE_LIST = {
  kyc: 1,
  curpDemotion: 2,
}

/**
 * 申卡新框架-提交授信错误码
 */
export const SUBMIT_ERRORCODE_LIST = {
  info_lack: 35908,
}

/**
 * 申卡流程中各页面标题列表（仅文案key)
 * 预授信，普通申卡，虚实分离新流程(含虚实分离和虚实同申)
 */
export const TITLE_LIST = {
  PRECREDIT: {
    FRONT_FACE:
      'financial.loan.freya.credit.face_guide.head.title',
    BASE_INFO_ONE:
      'financial.loan.baldr.credit.info1.title',
    CURP: 'financial.loan.baldr.credit.info2.title',
    CREDIT_AUTHORIZATION:
      'financial.loan.freya.credit.verification.head.title',
    PIN: 'financial.loan.baldr.migration.apply.pin.title',
    BASE_INFO_TWO:
      'financial.loan.baldr.credit.info3.title',
    OCR_SUBMIT: 'financial.loan.baldr.credit.info4.title',
    BACK_FACE: 'financial.loan.baldr.apply.face_title',
  },
  CREDIT: {
    FRONT_FACE:
      'financial.loan.freya.credit.face_guide.head.title',
    CURP: 'financial.loan.freya.credit.idname.title',
    BASE_INFO:
      'financial.loan.freya.credit.personal_info.head.title',
    CREDIT_AUTHORIZATION:
      'financial.loan.freya.credit.verification.head.title',
    PIN: 'financial.loan.baldr.migration.apply.pin.title',
    OCR_SUBMIT: 'financial.loan.baldr.apply.ine_title',
    BACK_FACE: 'financial.loan.baldr.apply.face_title',
  },
  CARD_SEPARATE: {
    CURP: 'financial.loan.baldr.credit.info2.title',
    OCR_SUBMIT: 'financial.loan.baldr.apply.ine_title',
    PIN: 'financial.loan.baldr.migration.apply.pin.title',
  },
}

/**
 * 弹窗拦截页面（二阶段提交时去往以下页面弹窗拦截）
 */
export const INTERCEPT_PAGE_LIST = {
  homePage: 'homePage',
  curp: 'curpPage',
}
/**
 * 完成步数
 */
export const COMPLETED_STEPS = {
  zero: 0,
  one: 1,
  two: 2,
  three: 3,
}
/**
 * 前置人脸跳过相关错误码
 * 103, //人脸比对失败
 * 104, //人脸识别超过次数限制
 * 106, //上传接口不能处理的其他错误
 */
export const FRONT_FACE_JUMP_CODE = {
  failed: '103',
  limit: '104',
  other: '106',
}

// 虚实分离场景在地址组件内的页面来源定义
export const VR_OMEGA_PAGE_SOURCE = 3

// 现金贷拒量引流协议埋点上报的场景定义 目前有征信授权和后置人脸
export const OMEGA_PAGE_SOURCE_VERIFICATION = {
  face: 'face',
  creditGrant: 'credit',
}

/**
 * 虚实分离新流程场景类型
 */
export const SCENES_TYPE_LIST = {
  vr_divide_A: 'cardSeparateAApplyScene',
  vr_divide_B: 'cardSeparateBApplyScene',
  vr_together: 'cardNotSeparateApplyScene',
  guide_drainage: 'refusesAttractLoanScene', // 拒量引流
  unknown: 'cardSeparateNormalApplyScene',
}

/**
 * 错误重试页面埋点上报场景类型
 */
export const ERROR_PAGE_SCENE_TYPE = {
  curp: 'curp',
  approval: 'approval',
}

/**
 * curp提交验证时后端返回的vendor类型
 */
export const CURP_VENDOR_TYPE = {
  unknown: 0,
  nubarium: 1,
  incode: 2,
}

/**
 * 重传页api返回的照片类型
 */
export const REUPLOAD_IMAGE_TYPE = {
  front: 0,
  back: 1,
  handheld: 2,
}

/**
 * 重传页照片标识
 */
export const REUPLOAD_IMAGE_INDEX = {
  front: 0,
  back: 1,
  handheld: 2,
}

// ocr查询接口返回的证件超期或过期类型标识
export const OCR_RESET_TYPE_LIST = {
  expired: 1,
  exceed: 2,
}

// 证件上传照片name标识
export const OCR_IMAGE_NAME = {
  front: 'front',
  back: 'back',
  hand: 'handheld',
}

/**
 * 现金贷静默授信可重试次数本地缓存key
 */
export const LOAN_RETRY_TIME_KEY = 'loan_retry_time'

/**
 * 现金贷静默授信可重试次数默认次数
 */
export const DEFAULT_LOAN_RETRY_TIMES = 2

/**
 * fin_credit_abroad_apply_home_loading_result_bt埋点的verify_result字段取值定义
 */
export const OMEGA_HOME_VERIFY_RESULT = {
  pass: 'pass',
  partial_pass: 'partial_pass',
  timeout: 'timeout',
}

/**
 * fin_credit_abroad_apply_home_sw埋点的if_cashloan_simplify字段取值定义
 */
export const OMEGA_HOME_CASHLOAN_SIMPLIFY = {
  yes: 1, // 展示现金贷缩减模块
  no: 0, // 不展示现金贷缩减模块
}

/**
 * fin_credit_abroad_apply_home_sw埋点的hasUC字段取值定义
 */
export const OMEGA_HOME_HASUC = {
  yes: 1, // 是现金贷用户
  no: 0, // 非现金贷用户
}

/**
 * fin_credit_abroad_apply_home_sw埋点的pre_approval字段取值定义
 */
export const OMEGA_HOME_PREAPPROVAL = {
  yes: 1, // 是预授信
  no: 0, // 不是预授信
}

/**
 * 静默授信申卡顶部进度条步骤数
 */
export const HEAD_STEPS = {
  one: 1,
  two: 2,
  three: 3,
}

/**
 * 静默授信申卡顶部进度条当前步骤对应百分比、
 * 比如说用户此时在步骤1，则进度展示为90%；如果到了步骤2，进度展示为95%。
 */
export const HEAD_PERCENTAGE_MAP = {
  [HEAD_STEPS.one]: '90%',
  [HEAD_STEPS.two]: '95%',
  [HEAD_STEPS.three]: '99%',
}

/**
 * 静默授信申卡顶部进度条当前步骤css样式宽度
 * 比如说用户此时在步骤1进度展示的文字为90%，但实际上高亮进度条的长度是80%
 */
export const HEAD_STYLE_WIDTH_MAP = {
  [HEAD_STEPS.one]: '80%',
  [HEAD_STEPS.two]: '85%',
  [HEAD_STEPS.three]: '90%',
}

/**
 * 静默授信申卡顶部进度条当前百分比所在位置（左偏移）
 * 比如说用户此时在步骤1进度展示的文字为90%，但实际上高亮进度条的长度是80%，然后进度条上百分比数字的位置是78%；
 */
export const HEAD_STYLE_LEFT_MAP = {
  [HEAD_STEPS.one]: '78%',
  [HEAD_STEPS.two]: '83%',
  [HEAD_STEPS.three]: '88%',
}

// 兜底默认值
// 百分比数字元素左偏移
export const DEFAULT_STYLE_LEFT = '78%'
// 当前高亮进度条长度
export const DEFAULT_STYLE_WIDTH = '80%'
// 当前进度展示文字
export const DEFAULT_STYLE_PERCENTAGE = '90%'

// 首页获取下一页接口中静默授信超时错误码
export const API_ERRORCODE_LOAN_TIMEOUT = 23002

// 现金贷静默授信接口默认超时时长 单位秒
export const DEFAULT_API_LOAN_APPLY_TIMEOUT = 10

/**
 * 申卡人脸stage参数标识
 */
export const FACE_STAGE = {
  front_face: 3,
  back_face: 1,
}

/**
 * 人脸sessionId申请参数faceAbility
 */
export const FACE_PARAMS_ABILITY = {
  facePlus: 1, // face++
  sstg: 0, // sstg 即默认人脸
}

/**
 * 人脸sdk验证渠道类型
 */
export const FACE_VERIFY_CHANNEL = {
  facePlus: 1, // face++
  sstg: 0, // 默认人脸
}

export const FACE_PARAMS_COUNTRY = 'MX'

/**
 * 人脸sdk状态码定义
 状态码<100，表示人脸识别通过，具体的错误码表示通过的原因
  0, //认证成功
  1, //白名单放行
  2, //身份证号和姓名可被查询到并确认一致，但公安网中没有此人的照片故无法比对(弹HUDToast)
  3, //表明系统故障，需要放过识别
  101, //业务线传递参数错误
  102, //用户手动取消了
  103, //人脸比对失败
  104, //人脸识别超过次数限制
  105, //用户信息不全，需要补全用户信息(弹HUDToast)
  106, //上传接口不能处理的其他错误
  107, //用户被踢出，很可能是账户信息不对
  108, //【未使用】由push强制用户退出识别，目前无用
  109, //【未使用】用户token失效
  112, //没有网络(没有连到internet)
  113, //系统异常
  114, //申诉审核中
  118, //SDK初始化失败
  120, //Face++活体检测失败
  */
export const FACE_SDK_CODE = {
  success: 0,
  in_whitelist: 1,
  correct: 2,
  system_passed: 3,
  params_error: 101,
  canceled: 102,
  verify_error: 103,
  verify_times_limited: 104,
  info_lack: 105,
  upload_error: 106,
  account_error: 107,
  force_exit: 108,
  token_expired: 109,
  network_error: 112,
  system_error: 113,
  apply_reviewing: 114,
  sdk_init_error: 118,
  face_plus_verify_error: 120,
}

// 人脸sdkomega埋点result参数定义
export const FACE_SDK_OMEGA_RESULT = {
  pass: 1,
  fail: 0,
}
// 人脸sdkomega埋点position参数定义
export const FACE_SDK_OMEGA_POSITION = {
  front: 1,
  back: 2,
}

// 申卡流程中唤起人脸时参数position定义
export const APPLY_FACE_POSITION = {
  front: 0,
  back: 1,
}

// 人脸sdkomega埋点if_success参数定义
export const FACE_SDK_OMEGA_IFSUCCESS = {
  success: 1,
  fail: 0,
}

// 允许申请信用卡的最小年龄和最大年龄
export const CURP_BIRTHDAY_LIMIT = {
  MIN_AGE: 18,
  MAX_AGE: 100,
}
// 征信授权确认验证码接口evaAuthorization参数定义 0-未开量 1-开量未勾选 2-开量已勾选
export const API_PARAMS_EVAAUTHORIZATION = {
  closed: 0,
  not_agree: 1,
  agree: 2,
}

// curp占用提交接口错误码定义
// 45004 - 人证不一致存在盗用风险，请用户改日再试
// 45005 - 其他手机使用了此curp提交了申请且在审核中
// 45006 - 其他手机使用了此curp提交了申请且申请成功
// 45007 - 其他手机使用了此curp提交了申请且申请被拒绝
export const CURP_CONFLICT_SUBMIT_CODE = {
  risk: 45004,
  reviewing: 45005,
  success: 45006,
  refused: 45007,
}

// ocr-submit用户状态机
export const OCR_USER_STATUS_LIST = {
  noPhoto: 1, // 所有照片未上传
  frontUploading: 2, // 正面照上传中
  onlyHasFront: 3, // 有正面照
  backUploading: 4, // 反面照上传中（正面已有）
  hasFrontAndBack: 5, // 有正面和反面
  handheldUploading: 6, // 手持上传中
  frontAndBackUploading: 7, // 正反面上传中（incode sdk以及现金贷同步）
}

// ocr门神参数-正反面
export const OCR_DOORGOD_PARAMS = {
  FRONT: {
    BIZCODE: '1020103',
    CARDARRAY: 'MX_S1',
  },
  BACK: {
    BIZCODE: '1020104',
    CARDARRAY: 'MX_S2',
  },
}

// ocr相机参数
export const OCR_CAMERA_PARAMS = {
  FRONT: {
    QUALITY: 0.7,
    WIDTH: 800,
    HEIGHT: 600,
  },
  BACK: {
    QUALITY: 0.7,
    WIDTH: 800,
    HEIGHT: 600,
  },
  HANDHELD: {
    QUALITY: 0.7,
    WIDTH: 800,
    HEIGHT: 600,
  },
}

// api返回用户应该去往ocr的哪个拆分页
export const OCR_CHILDPAGE_LIST = {
  front: 'FRONT', // 用户无数据 去正面拍摄引导
  back: 'BACK', // 用户有正面数据 去反面拍摄引导
  group: 'GROUP', // 用户有正反面数据 去手持拍摄引导
  frontLoading: 'FRONT_LOADING', // 用户需要同步数据 先同步正反 再同步手持
  groupLoading: 'GROUP_LOADING', // 用户需要同步数据 正反已有 仅同步手持
}

// ocr页面拆分后兜底的loading时间 单位秒
export const DEFAULT_OCR_TIMEOUT = 7

// ocr拆分页面的挽留弹窗key列表（缓存）
export const OCR_SPLIT_PAGE_BACKPOPUP_KEYLIST = {
  timestamp: 'lastDay', // 记录上一次弹窗时间的key
  count: 'savingPopupTimes', // 记录当天弹出次数的key
}

// ocr节点下不同场景标记 kyc中证件上传为1 curp降级时证件上传为2
export const OCR_SUBMIT_SCENE_LIST = {
  kyc: 1,
  curpDemotion: 2,
}

// 照片来源 0-未知 1-相机 2-门神 3-sdk
export const OCR_IMAGE_SOURCE = {
  unknown: 0,
  camera: 1,
  doorGod: 2,
  sdk: 3,
}

// 下一页接口中告知前端的重传类型
export const OCR_REUPLOAD_TYPE = {
  front: 'FRONT_BACK',
  hand: 'HAND',
  total: 'FRONT_BACK_HAND',
}

// 重传提交信审参数reuploadType 1:证件正面; 2:手持照; 3:证件正面及手持照
export const OCR_REUPLOAD_SUBMIT_TYPE = {
  front: 1,
  hand: 2,
  total: 3,
}
// 申卡首页场景列表
export const APPLY_HOME_SCENE_LIST = {
  credit: 1,
  precredit: 2,
}

// ocr拆分需求保存正反时后端给出的返回页面提示
export const OCR_SPLIT_RETURN_PAGE_LIST = {
  front: 'FRONT',
  back: 'BACK',
  group: 'GROUP',
}

export const COMMON_SERVER_ERROR = 20000

// ocr拆分单独上传完成功提示停留时间
export const OCR_SUBMIT_SUCCESS_STOP_TIME = 1000

// 发送给风控的设备指纹中对应的页面类型
/**
 *  HOMEPAGE --申卡首页（三个：预授信、申卡、二段式申请一阶段通过-A实验）
    CURPPAGE ---CURP页
    CREDITGRANTPAGE --征信验证码
    PINPAGE ---设置pin码
    CARDSEPARATEPERSONALINFO1-个人信息页1
    CARDSEPARATEPERSONALINFO2-个人信息页2
    CARDSEPARATEPERSONALINFO3-个人信息页3
    CARDSEPARATEPERSONALINFO4-个人信息页4
    OCRSUBMIT-证件上传页 （仅主流程）
    FIRSTFACEDETECTION---前置人脸
    POSTFACEDETECTION---后置人脸
 */
export const RISK_PAGETYPE_LIST = {
  homepage: 'HOMEPAGE',
  frontFace: 'FIRSTFACEDETECTION',
  personal1: 'CARDSEPARATEPERSONALINFO1',
  curp: 'CURPPAGE',
  authorization: 'CREDITGRANTPAGE',
  pin: 'PINPAGE',
  personal2: 'CARDSEPARATEPERSONALINFO2',
  personal3: 'CARDSEPARATEPERSONALINFO3',
  personal4: 'CARDSEPARATEPERSONALINFO4',
  ocrsubmit: 'OCRSUBMIT',
  backFace: 'POSTFACEDETECTION',
}

export const OCR_SCENE_TYPE = {
  kyc: 1,
  curpDemotion: 2,
}

//年龄挡板 年龄校验不通过code
export const AGECHECK_CODE = {
  NOT_PASSED: 51000,
}

export const GuidePage = {
  CURPGUIDE: '7',
  BASEINFOGUIDE: '8',
  VERIFICATIONGUIDE: '9',
  ADRESSGUIDEONE: '10',
  ADRESSGUIDETWO: '11',
  CONTRACT_PREVIEW: '23',
  PHASEONE_WAITING: '26',
  GUIDE_DRAINAGE: '27',
}

// curp无效客服电话
export const CURP_NOT_VALID_PHONE = {
  text: '800 911 1111',
  value: '8009111111',
}

/**
 * curp提交接口错误码相关
 */
export const CURP_SUBMIT_CODE = {
  // curp无效类错误 具体解释参考 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=1103771169
  notValidCurp: {
    BAP: 38114,
    BSU: 38115,
    BD: 38116,
    BDM: 38117,
    BDP: 38118,
    BJD: 38119,
  },
  // curp校验失败类错误
  failedCurp: {
    notValidDoc: 38015, // 您的证件无效，请重新核实后申请(新)
    notValidFormat: 38016, // 您的证件格式无效，请重新核实后申请(新)
    inconsistentCurp: 38017, // curp校验失败，curp号不一致(新)
  },
  //  curp占用
  curpConflict: {
    //curp被其他手机使用
    used: 45000,
    //45001 - curp被其他手机使用且提交过申请
    hasApply: 45001,
    // 45002 - curp被其他手机删除
    hasDelete: 45002,
    //curp被其他手机使用，可以继续用此curp申请（一期占用（人证不一致占用））
    continue: 45003,
    //人证不一致存在盗用风险，请用户改日再试
    risk: 45004,
    // curp被其他手机占用，允许通过会员域换绑（会员域占用（人证一致占用））
    findAccount: 45009,
    // curp被其他手机使用且在审批中（业务线拦截）
    isReviewing: 45010,
    // curp被其他手机申卡成功（业务线拦截）
    hasGotCard: 45011,
    // 会员域CURP占用（统一KYC用户的CURP占用）
    fintechHave: 39102,
    //统一kyc占用
    kycConflict: 39103,
  }
}

/**
 * 用户数据来源
 * 0 - none
 * 1 - minsait
 * 2 - didi
 * 3 - minsait&didi
 */
export const USER_FLAG = {
  NONE: 0,
  MINSAIT: 1,
  DIDI: 2,
  ALL: 3,
}